import React from 'react';
import {CircularProgress} from '@mui/material';
import {Body} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import type {CampaignProps} from '@/types/campaign';
import styles from './CampaignBriefViewer.module.scss';
import CampaignBriefHeader from './shared/CampaignBriefHeader';
import CampaignBriefStats from './shared/CampaignBriefStats';
import AiBriefViewer from './variants/AiBriefViewer';
import LegacyBriefViewer from './variants/LegacyBriefViewer';

interface CampaignBriefViewerProps {
  campaign?: CampaignProps;
  isLoading?: boolean;
}

function CampaignBriefViewer({campaign, isLoading}: CampaignBriefViewerProps) {
  if (isLoading) {
    return (
      <div className={styles.spinner}>
        <CircularProgress />
      </div>
    );
  }

  if (!campaign) {
    return <Body size="md">{translate('No brief available')}</Body>;
  }

  return (
    <div className={styles.container}>
      <CampaignBriefHeader campaign={campaign} />
      <CampaignBriefStats campaign={campaign} />
      {campaign.generatedByBriefAi ? (
        <AiBriefViewer campaign={campaign} />
      ) : (
        <LegacyBriefViewer campaign={campaign} />
      )}
    </div>
  );
}

export default CampaignBriefViewer;
